import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { IPlan } from '../../types/plan'

export interface IPlansState extends IAjaxBaseState<IPlan> {
}

const createInitialPlansState = (): IPlansState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialPlansState
}
